import { Container, Row, Col} from "react-bootstrap";
import { motion } from "framer-motion";
import image1 from './assets/ananya.jpeg'
import image3 from './assets/rajesh.jpeg'
import image4 from './assets/image4.jpg'
import image5 from './assets/prasad.jpeg'
import image6 from './assets/image6.jpg'
import image2 from './assets/avni.jpeg'

const testimonials = [
  {
    id: 1,
    name: "Malti",
    designation: "COO, MK engineering",
    image: image1,
    content: `Our digital transformation journey accelerated rapidly after adopting this platform. 
It integrates seamlessly across departments and enables data-driven decision-making. 
The AI-powered insights have improved our operational efficiency and innovation speed.`
  },
  {
    id: 2,
    name: "Abani Datta",
    designation: "Project Manager, JMBAXI",
    image: image2,
    content: `This platform has streamlined our end-to-end business processes. 
From team coordination to project delivery, everything runs more smoothly. 
We’ve significantly reduced manual errors and improved turnaround times.`
  },
  {
    id: 3,
    name: "Rajesh Kumar",
    designation: "Technology Head, TNDPC",
    image: image3,
    content: `As a GM overseeing multiple units, I appreciate how this system brings visibility and control. 
It keeps my teams aligned with clear KPIs and real-time progress tracking. 
We’ve seen a 30% improvement in project delivery consistency.`
  },
  {
    id: 4,
    name: "Soraya Khan",
    designation: "SR ,Isazi Consulting",
    image: image4,
    content: `Our organization has scaled effortlessly thanks to this platform. 
It provides the transparency and insights we need to make confident business decisions. 
The automation features have freed up valuable time for strategic innovation.`
  },
  {
    id: 5,
    name: "S Prasad",
    designation: "CTO, PR Pumps",
    image: image5,
    content: `Managing budgets and forecasting growth has become far more efficient. 
The platform’s analytics capabilities make it easy to visualize financial trends. 
It’s a must-have tool for any data-driven finance leader.`
  },
  {
    id: 6,
    name: "Olivia Thompson",
    designation: "Marketing Director, Cortex AI",
    image: image6,
    content: `Our marketing performance tracking is now faster and smarter. 
With real-time data visualization and automation, campaign adjustments are instant. 
The insights we gain from customer analytics are shaping our strategy every quarter.`
  }
];


const Testimonial = () => {
  return (
    <section
      style={{
       background: "linear-gradient(90deg, #F6D5F7 0%, #b5d7e4ff 100%)",
        padding: "60px 20px",
        overflowX: "hidden", 
      }}
    >
        <h1
          className="text-center mt-4 fw-bold mb-5"
          style={{
            fontFamily: "'Roboto', sans-serif",
            fontSize: "2.8rem",
            letterSpacing: "0.5px",
            lineHeight: "1.3",
            textTransform: "uppercase",
            color: "#0f0e0eff",
          }}
        >
          Testimonials
        </h1>
      <Container fluid>
        <Row className="gy-4">
          {testimonials.map((t, index) => {
            const fromDirection = index < 3 ? -80 : 80; // a bit bigger offset but hidden by overflow

            return (
              <Col md={4} key={t.id} className="d-flex">
                <motion.div
                  initial={{ opacity: 0, x: fromDirection }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: false, amount: 0.2 }}
                  style={{ flex: 1, overflow: "hidden" }} // ✅ ensure no horizontal scroll
                >
                  <motion.div
                    whileHover={{
                      scale: 1.03,
                      boxShadow:
                        "0 0 20px rgba(255,102,204,0.8), 0 0 40px rgba(126,34,206,0.8)",
                      borderColor: "rgba(255,102,204,0.8)",
                      transition: { duration: 0.3, ease: "easeInOut" },
                    }}
                    style={{
                      background:
                        "linear-gradient(135deg, rgba(255,102,204,0.15), rgba(126,34,206,0.15))",
                      border: "1px solid rgba(255,255,255,0.2)",
                      color: "white",
                      padding: "20px",
                      borderRadius: "16px",
                      backdropFilter: "blur(8px)",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      color: "black"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "15px",
                      }}
                    >
                      <div>
                        <h5 style={{ margin: 0 }}>{t.name}</h5>
                        <small style={{ color: "#171515ff" }}>
                          {t.designation}
                        </small>
                      </div>
                      <img
                        src={t.image}
                        alt={t.name}
                        style={{
                          width: "65px",
                          height: "65px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          marginLeft: "15px",
                          border: "2px solid #ff66cc",
                          boxShadow:
                            "0 0 12px rgba(255,102,204,0.8), 0 0 20px rgba(126,34,206,0.7)",
                        }}
                      />
                    </div>
                    <p
                      style={{
                        fontStyle: "italic",
                        color: "#0b0b0bff",
                        textAlign: "justify",
                        marginTop: "auto",
                      }}
                    >
                      “{t.content}”
                    </p>
                  </motion.div>
                </motion.div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Testimonial;
